<template>
    <div class="device-attributes__wrapper" style="border-top: 1px solid #e6e6e6;">
      <b-card>
        <themed-tree :items="transformedData" :trackBy="'id'" :label="'label'" :searchEnabled="true"></themed-tree>
      </b-card>
    </div>
  </template>
  <script>
  import Vue from "vue";
  import VueToast from "vue-toast-notification";
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";
  import ThemedTree from "../../../shared/careai/components/ThemedTree.vue";
  import BedManagerService from "../BedManager.service";

  const moment = require("moment");
  
  Vue.use(VueToast);
  Vue.use(Loading);
  Vue.component('themed-tree', ThemedTree);
  
  export default {
    name: "DeviceAttributes",
    components: { },
    data() {
      return {
        console: console,
        moment: moment,
        // Singleton Pattern Service
        // Contains State and API Requests
        bedManagerService: BedManagerService,
      };
    },
    computed: {
      transformedData() {
        return this.bedManagerService.selectedDevice.data;
      },
    },
    watch: {},
    mounted() {
      this.bedManagerService.fetchDeviceAttributes();
    },
    unmounted() {},
    methods: {},
  };
  </script>
  
  <!-- Header Styles -->
  <style lang="scss">
    .device-attributes__wrapper {
      .card-body {
        flex: 1 1 auto;
        min-height: 1px;
        font-size: 15px;
        margin: 15px;
        border-radius: 5px;
        border: 1px solid #dee2e6;
        border-bottom: none;
        padding: 0;
      }
    }
  </style>  
  
  <style>
  ::-webkit-scrollbar {
    width: 6px; 
    height: 6px;
  }</style>
  